import { useQuery } from "@tanstack/react-query";
import { fetchEstacionamientos } from "../features/estacionamiento/lib/fetchEstacionamientos";
import { Estacionamiento } from "../types/Estacionamiento";
import { logger } from "../utils/logger";

export const useEstacionamientos = () => {
  logger.debug("🔍 [useEstacionamientos] Hook ejecutándose");
  const result = useQuery<Estacionamiento[]>({
    queryKey: ["estacionamientos"],
    queryFn: fetchEstacionamientos,
    staleTime: 5 * 60 * 1000, // 5 minutos
    cacheTime: 10 * 60 * 1000, // 10 minutos
  });

  logger.debug("🔍 [useEstacionamientos] Resultado:", {
    data: result.data,
    isLoading: result.isLoading,
    error: result.error,
    isError: result.isError,
  });

  return result;
};
